AOS.init({
    offset: 150,
    once: true,
});

var searchIcon = document.querySelector('.header-controls-search-icon');
var searchBar = document.querySelector('.header-controls-searchbar');

searchIcon.addEventListener('click', () => {
    if(searchBar.classList.contains('show')) {
        searchBar.classList.remove('show');
    } else {
        searchBar.classList.add('show');
    }
});

const accordions = document.querySelectorAll('.accordion--title');

accordions.forEach((accordion) => {
    accordion.addEventListener('click', () => {
        let accordContent = accordion.parentElement;
        if(accordContent.classList.contains('open')) {
            accordContent.classList.remove('open');
        } else {
            accordContent.classList.add('open');
        }
    })
});

const benefitsSwiper = new Swiper('.benefits-swiper', {
    effect: 'slide',
    slidesPerView: 7,
    spaceBetween: 35,
    loop: true,
    grabCursor: true,
    navigation: {
      nextEl: '.benefits-next',
      prevEl: '.benefits-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 2,
            spaceBetween: 15,
            slidesPerGroup: 1,
        },
        380: {
            slidesPerView: 2,
            spaceBetween: 25,
            slidesPerGroup: 1,
        },
        500: {
            slidesPerView: 3,
            spaceBetween: 25,
            slidesPerGroup: 1,
        },
        767: {
            slidesPerView: 4,
            spaceBetween: 25,
            slidesPerGroup: 1,
        },
        800: {
            slidesPerView: 5,
            spaceBetween: 25,
            slidesPerGroup: 1,
        },
        1000: {
            slidesPerView: 6,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
        },
        1100: {
            spaceBetween: 35,
            slidesPerView: 7,
            slidesPerGroup: 1,
            enabled: false,
        },
    },
  });

  function swiperBundle() {
    return new Swiper('.benefits-swiper-bundle', {
    init:false,
    effect: 'slide',
    slidesPerView: 7,
    spaceBetween: 35,
    loop: true,
    grabCursor: true,
    navigation: {
      nextEl: '.benefits-next',
      prevEl: '.benefits-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 2,
            spaceBetween: 15,
            slidesPerGroup: 1,
        },
        380: {
            slidesPerView: 2,
            spaceBetween: 25,
            slidesPerGroup: 1,
        },
        500: {
            slidesPerView: 3,
            spaceBetween: 25,
            slidesPerGroup: 1,
        },
        767: {
            slidesPerView: 4,
            spaceBetween: 25,
            slidesPerGroup: 1,
        },
        800: {
            slidesPerView: 5,
            spaceBetween: 25,
            slidesPerGroup: 1,
        },
        1000: {
            slidesPerView: 6,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
        },
        1100: {
            spaceBetween: 35,
            slidesPerView: 7,
            slidesPerGroup: 1,
            enabled: false,
        },
    },
  });
}

setTimeout(function(){
  const benefitsSwiperBundle = swiperBundle();
  benefitsSwiperBundle.init();
}, 5000);
  

  document.addEventListener("customEvent", function(event) {
    const recommendationsSwiper = new Swiper('.recommendations-swiper', {
        effect: 'slide',
        loop: true,
        slidesPerView: 2,
        spaceBetween: 35,
        grabCursor: true,
        navigation: {
          nextEl: '.recommendations-next',
          prevEl: '.recommendations-prev',
        },
        breakpoints: {
            300: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            500: {
                slidesPerView: 2,
                slidesPerGroup: 1,
            },
            767: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                enabled: true,
            },
            1000: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                enabled: false,
            }
        },
      });
});

const animationDuration = 2000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round( animationDuration / frameDuration );
const easeOutQuad = t => t * ( 2 - t );
let alreadyCounted = false;

const animateCountUp = el => {
    let frame = 0;
    const countTo = parseFloat( el.innerText, 10 );

    const counter = setInterval( () => {
        frame++;
        const progress = easeOutQuad( frame / totalFrames );

        let currentCount = ( countTo * progress ).toFixed(1);
    
        if ( parseInt( el.innerText, 10 ) !== this.currentCount ) {
            el.innerHTML = currentCount;
        }

        if ( frame === totalFrames ) {
            clearInterval( counter );
            alreadyCounted = true;
        }
    }, frameDuration );
};

const runAnimations = () => {
    const countupEls = document.querySelectorAll( '.countup' );
    countupEls.forEach( animateCountUp );
};

const options = {
    // rootMargin: '-100px',
    rootMargin: '0px',
    threshold: 1.0
};
const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
            if(!alreadyCounted) {
                runAnimations();
            }
        }
    });
}, options);

const compareNumbers = document.getElementById('compareNumbers');
if(compareNumbers) {
    observer.observe(compareNumbers);
}

const looxReviews = document.getElementById('looxReviews');
if(looxReviews) {
    looxReviews.parentElement.classList.add('product-reviews');
}

const looxScroll = document.querySelector('.loox-scroll');

if(looxScroll) {
    looxScroll.addEventListener('click', () => { 
        var topOfElement = looxReviews.offsetTop - 66;
        window.scroll({
            top: topOfElement,
            behavior: "smooth"
        });
    });
}

var thumbSwiper = new Swiper(".thumbSwiper", {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
  });
var productSwiper = new Swiper(".productSwiper", {
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
});

const swiperArrows = document.querySelectorAll('.product-arrows');
const productViewport = document.querySelector('.productSwiper');

if(swiperArrows && productViewport) {
    productViewport.addEventListener('mouseover', () => {
        swiperArrows.forEach(arrow => {
            if(arrow.classList.contains('swiper-button-disabled')) {
                arrow.style.opacity = '0.35';
            } else {
                arrow.style.opacity = '1';
            }
        })
    });
    productViewport.addEventListener('mouseleave', () => {
        swiperArrows.forEach(arrow => {
            arrow.style.opacity = '0';
        })
    });
}

AOS.refresh();